export const SECTION = 'section'
export const EXAM = 'exam'
export const ESSAY = 'essay'
export const ASSIGNMENT = 'assignment'
export const FINAL_GRADE = 'finalGrade'
export const COURSERA_ACTIVITY = 'coursera activity'
export const BREAK = 'break'
